export default {
	collapseMenu(state) { //可以修改state,只能执行同步操作
		state.isCollapse = !state.isCollapse
	},
}
